__turbopack_context__.v({
  "buy-now-button": "index-module-scss-module__V5rxzq__buy-now-button",
  "send-offer-button": "index-module-scss-module__V5rxzq__send-offer-button",
});
